import styled from 'styled-components';

import { colors } from 'global/colors';

export const EditorContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;

  span.ace_comment {
    color: ${({ theme }) => theme.freecode.commentColor};
  }

  .ace_editor {
    .ace_active-line {
      background-color: ${({ theme }) => theme.freecode.activeAreaFocusColor};
    }
  }

  .ace-monokai {
    background: ${({ theme }) => theme.freecode.activeAreaBackgroundColor};
    .ace_gutter {
      background: ${({ theme }) => theme.freecode.activeAreaBackgroundColor};
    }
    .ace_gutter-active-line {
      background-color: ${({ theme }) => theme.freecode.activeAreaFocusColor};
    }
  }
  .ace-tomorrow {
    .ace_gutter {
      background: ${({ theme }) => theme.freecode.activeAreaBackgroundColor};
    }
    .ace_gutter-active-line {
      background-color: ${({ theme }) => theme.freecode.activeAreaFocusColor};
    }
  }
`;

export const SolutionButtonContainer = styled.span`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding-bottom: 3px;
  border-bottom: 1px solid ${colors.darkGray};
`;

export const CodeContainer = styled.div`
  width: 100%;
  height: calc(100% - ${({ smallScreenOffset }) => smallScreenOffset}px);
  overflow: hidden;
`;
